import { render } from "./StripeWebIntegrationSettings.vue?vue&type=template&id=3f5070ea"
import script from "./StripeWebIntegrationSettings.vue?vue&type=script&lang=js"
export * from "./StripeWebIntegrationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__